import { useModalCustomOptions } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"

import BridgeDepositModal from "./BridgeDepositModal"
import BridgeNewAssetModal from "./BridgeNewAssetModal"

export default function BridgeAssetModal(props: MezoModalProps) {
  const { depositId } = useModalCustomOptions<{
    depositId: number
  }>()

  if (depositId) {
    return <BridgeDepositModal {...props} />
  }

  return <BridgeNewAssetModal {...props} />
}
